import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';

import { StoreRouterConnectingModule } from '@ngrx/router-store';
import {reducers} from '@store/app.reducers';

import { SocialLoginModule, AuthServiceConfig, GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';

import { AppComponent } from './app.component';
import { LayoutModule } from '@angular/cdk/layout';
import { UserComponent} from '@layouts/user/user.component';
import { DashboardComponent } from '@components/dashboard/dashboard.component';
import { TableComponent } from '@components/table/table.component';

import {AppRoutingModule} from './app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {SharedModule} from '@sharedModules/shared-module/shared-module.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import {MainInterceptor} from '@services/interceptors/main.interceptor';
import {AuthInterceptor} from '@services/interceptors/auth.interceptor';
import {MetaReducer, StoreModule} from '@ngrx/store';
import {environment} from '../environments/environment';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {AuthService} from '@services/auth/auth.service';
import {AuthFacade} from '@app/facades/auth/authFacade';
import {MainMenuComponent} from '@components/main-menu/main-menu.component';
import {AppSidebarComponent} from '@components/app-sidebar/app-sidebar.component';
import {AdminAddComponent} from '@pages/layout/admin/admin-add/admin-add.component';
import {SchoolService} from '@services/school/school.service';
import {AccountService} from '@services/account/account.service';
import {NgxMaskModule} from 'ngx-mask';
import {StudentCreateComponent} from '@pages/layout/student/student-create/student-create.component';
import {StudentAddComponent} from '@pages/layout/student/student-add/student-add.component';
import {ProgramCreateComponent} from '@pages/layout/program/program-create/program-create.component';
import { TimeInputComponent } from './components/time-input/time-input.component';
import {SubscriptionModule} from '@pages/layout/subscription/subscription.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { UserValidators } from './user-validators';
import {UrlService} from '@services/url/url.service';


export const metaReducers: MetaReducer<any>[] = environment.production
  ? []
  : []; // [storeFreeze]


export function getAuthServiceConfigs() {
  const config = new AuthServiceConfig(
    [
      {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider('')
      },
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        // 923212722589-pkjsfjpnbm9qalc949ll3bsoo85q0l1d.apps.googleusercontent.com
        // 205237519685-6b3iil6vv0scp18jpt9v6fucfqutqmu4.apps.googleusercontent.com
        provider: new GoogleLoginProvider('923212722589-pkjsfjpnbm9qalc949ll3bsoo85q0l1d.apps.googleusercontent.com')
      },
    ]
  );
  return config;
}
const useSysSubdomain = window.location.hostname === 'sys.mykoolcat.com';
@NgModule({
  declarations: [
    AppComponent,
    UserComponent,
    DashboardComponent,
    TableComponent,
    MainMenuComponent,
    AppSidebarComponent,
    // CreateSchoolComponent,
    AdminAddComponent,
    StudentCreateComponent,
    StudentAddComponent,
    ProgramCreateComponent,
    TimeInputComponent
  ],
  imports: [
    NgxMaskModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    SubscriptionModule,
    LayoutModule,
    SharedModule,
    HttpClientModule,
    StoreRouterConnectingModule,
    StoreModule.forRoot(reducers, {metaReducers}),
    // EffectsModule.forRoot([AuthEffects, ProgramEffects]),
    !environment.production
      ? StoreDevtoolsModule.instrument({maxAge: 50})
      : [],
    SocialLoginModule,
    PdfViewerModule,
    // OwlDateTimeModule,
    // OwlNativeDateTimeModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AuthService,
    AccountService,
    UrlService,
    SchoolService,
    AuthFacade,
    UserValidators,
    {provide: HTTP_INTERCEPTORS, useClass: MainInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: AuthServiceConfig, useFactory: getAuthServiceConfigs},
  ],
  bootstrap: [AppComponent],
  entryComponents: [ProgramCreateComponent, AdminAddComponent,/*CreateSchoolComponent,*/ StudentCreateComponent, StudentAddComponent],
})
export class AppModule { }
